"use client"

import { Image } from "@heroui/image"

export function MainBackground() {
  return (
    <div className="fixed inset-0 z-0 opacity-10 pointer-events-none">
      <Image
        radius="none"
        src="/background-image.jpg"
        classNames={{
          img: "w-screen h-screen object-cover grayscale",
        }}
        removeWrapper
      />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-50 via-transparent to-slate-50 dark:from-slate-950 dark:to-slate-950" />
    </div>
  )
}